import { render } from "./PrivateFileImage.vue?vue&type=template&id=542f62a2&scoped=true"
import script from "./PrivateFileImage.vue?vue&type=script&lang=js"
export * from "./PrivateFileImage.vue?vue&type=script&lang=js"

import "./PrivateFileImage.vue?vue&type=style&index=0&id=542f62a2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-542f62a2"]])

export default __exports__